// File: src/pages/VisiGift/VisiGiftFAQ.jsx
import React, { useState } from "react";

const faqData = {
  "User": [
    // Negative
    {
      sentiment: "negative",
      question: "I don’t have time to watch long ads — is this worth it?",
      answer:
        "Absolutely! Most ads are short (15-30 seconds), and you earn points instantly for landing on the home page and simple button clicks. Start small and redeem for shopping perks on Think5Whys.",
    },
    {
      sentiment: "negative",
      question: "What if I don’t see any ads relevant to me?",
      answer:
        "No worries — the platform personalizes ads based on your interests. If none show, you still earn daily landing bonuses and button interaction points to build your rewards.",
    },
    {
      sentiment: "negative",
      question: "Can I really redeem points for actual shopping value?",
      answer:
        "Yes! Points are equivalent to discounts (e.g., 100 points = ₹10 off) on Think5Whys platform for gadgets, books, and more. Thousands of users have already redeemed successfully.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "How do I track my points and redemptions?",
      answer:
        "Your dashboard shows real-time points, streak bonuses, and redemption history. One-tap access to apply points at checkout on Think5Whys shopping.",
    },
    {
      sentiment: "neutral",
      question: "Is there a minimum points threshold to redeem?",
      answer:
        "Minimal threshold — start redeeming from 50 points. Build more through daily visits, button clicks, and ad interactions for bigger savings.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How quickly can I start earning points?",
      answer:
        "Instantly! Land on the VisiGift home, click any button, and points add up. Daily bonuses reward consistency for effortless growth.",
    },
    {
      sentiment: "positive",
      question: "Can I share my earnings with family or friends?",
      answer:
        "Yes! Transfer points to linked accounts or invite referrals for bonus points, turning your rewards into shared shopping benefits on Think5Whys.",
    },
  ],

  "Advertisers": [
    // Negative
    {
      sentiment: "negative",
      question: "Will my ads reach the right audience without wasting budget?",
      answer:
        "Targeted precisely by demographics, interests, and location. Track views, clicks, and conversions in real-time to optimize spend effectively.",
    },
    {
      sentiment: "negative",
      question: "What if users skip my ads too quickly?",
      answer:
        "Engagement is incentivized with points for interaction, boosting completion rates. Short, rewarding formats ensure higher visibility and ROI.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "What ad formats does VisiGift support?",
      answer:
        "Flexible options: static images, short videos, interactive buttons, and sponsored landing pages — all integrated seamlessly for user-friendly delivery.",
    },
    {
      sentiment: "neutral",
      question: "How do I measure campaign performance?",
      answer:
        "Detailed analytics dashboard with metrics like impressions, engagement rates, and point-driven conversions, exportable for your reports.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "Can VisiGift amplify my brand's reach cost-effectively?",
      answer:
        "Yes! Leverage viral button shares and user streaks for organic growth, with points encouraging repeat exposure and direct Think5Whys shopping ties.",
    },
    {
      sentiment: "positive",
      question: "How does partnering boost my sales funnel?",
      answer:
        "Users earn points for engaging with your ads, redeemable on platforms like Think5Whys — creating a rewarding path from awareness to purchase.",
    },
  ],

  "Influencer": [
    // Negative
    {
      sentiment: "negative",
      question: "Do I get compensated fairly for promoting ads?",
      answer:
        "Competitive rates based on your reach and engagement, plus bonus points or commissions from driven redemptions on Think5Whys.",
    },
    {
      sentiment: "negative",
      question: "What if my audience doesn’t engage with VisiGift content?",
      answer:
        "Tailored campaigns match your niche; track performance and adjust. Many influencers see 20-30% uplift in follower interactions via rewarded shares.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "How do I collaborate on VisiGift campaigns?",
      answer:
        "Easy signup via dashboard: select ads, customize endorsements, and schedule posts. Tools for seamless integration with your social channels.",
    },
    {
      sentiment: "neutral",
      question: "Can I promote local or niche brands?",
      answer:
        "Yes! Spotlight exhibitors or boutiques with geo-targeted rewards, earning from authentic endorsements that resonate with your community.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How can this grow my influence and earnings?",
      answer:
        "Amplify reach through VisiGift's point ecosystem — followers earn while engaging, boosting your credibility and opening sponsored opportunities.",
    },
    {
      sentiment: "positive",
      question: "Will this integrate with my existing content strategy?",
      answer:
        "Perfectly! Embed ad buttons or videos in your posts, with analytics showing how rewards drive traffic back to your channels and Think5Whys.",
    },
  ],

  "Exhibitors": [
    // Negative
    {
      sentiment: "negative",
      question: "Is setting up an exhibit expensive or complicated?",
      answer:
        "Low-barrier entry: free basic listings, pay-per-engagement for premium visibility. Simple drag-and-drop tools for quick setup.",
    },
    {
      sentiment: "negative",
      question: "How do I stand out among other exhibitors?",
      answer:
        "Highlight with custom buttons, video showcases, and point multipliers. User interactions earn them rewards, driving more traffic to you.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "What types of products can I exhibit?",
      answer:
        "Anything from local crafts to digital services — integrate with Think5Whys for seamless redemption and sales tracking.",
    },
    {
      sentiment: "neutral",
      question: "How does VisiGift handle logistics for exhibits?",
      answer:
        "Virtual-first with optional local pickups; partner with exhibitors leads for streamlined inquiries and fulfillment.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "Can exhibiting lead to direct sales growth?",
      answer:
        "Yes! Button clicks trigger point earnings, funneling users to your Think5Whys cart for instant redemptions and purchases.",
    },
    {
      sentiment: "positive",
      question: "How does this connect me with local buyers?",
      answer:
        "Geo-targeted ads and boutique tie-ins ensure community reach, with leads routed for personalized follow-ups.",
    },
  ],

  "Exhibitors Lead": [
    // Negative
    {
      sentiment: "negative",
      question: "What if leads from users are low-quality?",
      answer:
        "Qualified via point-earning interactions — only engaged users proceed, with filters for intent and location to ensure relevance.",
    },
    {
      sentiment: "negative",
      question: "How do I manage a high volume of inquiries?",
      answer:
        "Built-in CRM tools in the dashboard: auto-categorize, schedule responses, and integrate with your exhibitor's sales pipeline.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "How are leads generated from VisiGift?",
      answer:
        "Through button clicks, ad views, and redemption intents — captured as hot leads tied to Think5Whys shopping behaviors.",
    },
    {
      sentiment: "neutral",
      question: "Can I access lead data analytics?",
      answer:
        "Yes: Track conversion rates, demographics, and point values per lead for optimizing your exhibitor's campaigns.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How does this accelerate sales closures?",
      answer:
        "Pre-warmed leads from rewarded engagements mean higher close rates — redeem points directly for exclusive deals.",
    },
    {
      sentiment: "positive",
      question: "Will this integrate with my existing lead tools?",
      answer:
        "Seamlessly: Export to CRM, email, or local boutique systems, with real-time notifications for quick follow-up.",
    },
  ],

  "Local Ad Boutique Owner": [
    // Negative
    {
      sentiment: "negative",
      question: "Can small local businesses afford VisiGift ads?",
      answer:
        "Budget-friendly: Start with micro-campaigns at ₹100/day, scaling with performance. Earn from user redemptions on Think5Whys too.",
    },
    {
      sentiment: "negative",
      question: "What if my local area has low digital adoption?",
      answer:
        "Voice-guided, low-data ads ensure accessibility. Partner with influencers for community trust and higher engagement.",
    },
    // Neutral
    {
      sentiment: "neutral",
      question: "How do I create ads for my boutique?",
      answer:
        "User-friendly builder: Upload photos/videos of products, set point rewards, and target nearby users via geo-fencing.",
    },
    {
      sentiment: "neutral",
      question: "Can I collaborate with exhibitors or influencers?",
      answer:
        "Yes! Co-create campaigns, share leads, and split rewards — all managed from your local dashboard.",
    },
    // Positive
    {
      sentiment: "positive",
      question: "How will this boost footfall to my boutique?",
      answer:
        "Point-driven incentives send users your way for redemptions, with trackable paths from ad click to in-store visit.",
    },
    {
      sentiment: "positive",
      question: "Does VisiGift support community-focused promotions?",
      answer:
        "Tailor-made: Highlight local events, tie-ins with exhibitors, and earn collective points for group redemptions on Think5Whys.",
    },
  ],
};

// Sentiment color mapping
const sentimentColors = {
  negative: "text-purple-400",
  neutral: "text-gray-400",
  positive: "text-green-400",
};

export default function VisiGiftFAQ() {
  const stakeholders = Object.keys(faqData);
  const [selectedStakeholder, setSelectedStakeholder] = useState(stakeholders[0]);
  const [expandedIndex, setExpandedIndex] = useState(null);

  return (
    <div className="min-h-screen bg-gray-950 text-white p-4 sm:p-8">
      <h1 className="text-lg sm:text-xl font-bold mb-6 text-center text-purple-400">
        VisiGift – FAQ
      </h1>

      {/* Stakeholder Tabs */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2 mb-6">
        {stakeholders.map((stakeholder) => (
          <button
            key={stakeholder}
            onClick={() => {
              setSelectedStakeholder(stakeholder);
              setExpandedIndex(null);
            }}
            className={`px-4 py-2 rounded-md font-semibold text-sm sm:text-base transition-all duration-200 ${
              selectedStakeholder === stakeholder
                ? "bg-purple-500 text-white"
                : "bg-gray-800 hover:bg-gray-700"
            }`}
          >
            {stakeholder}
          </button>
        ))}
      </div>

      {/* FAQ List */}
      <div className="max-w-4xl mx-auto">
        {faqData[selectedStakeholder].map((faq, index) => (
          <div
            key={index}
            className="border-b border-gray-700 py-3 cursor-pointer"
            onClick={() => setExpandedIndex(expandedIndex === index ? null : index)}
          >
            <div className="flex justify-between items-center">
              <h3 className={`font-medium ${sentimentColors[faq.sentiment]}`}>
                {faq.question}
              </h3>
              <span className="text-gray-400 text-xl">
                {expandedIndex === index ? "-" : "+"}
              </span>
            </div>
            {expandedIndex === index && (
              <p className="mt-2 text-gray-300">{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}